export default "__VITE_ASSET__B9yNW5dG__"